import instance from '@/utils/axios';

/**
 * 获取人员列表
 * @param {*} data
 * @returns
 */
export function personListServer(data) {
  return instance.post('airDefense/emergencyCrew/findList', data);
}

/**
 * 获取专家列表
 * @param {*} data
 * @returns
 */
export function expertListServer(data) {
  return instance.post('airDefense/emergencyExpert/findList', data);
}

/**
 * 获取物资列表
 * @param {*} data
 * @returns
 */
export function materialsListServer(data) {
  return instance.post('airDefense/emergencyGoods/findList', data);
}
